import { Component, Element, h, Host } from '@stencil/core';

@Component({
  tag: 'pn-line-shape',
  styleUrl: 'pn-line-shape.scss',
})
export class PnLineShape {
  @Element() hostElement: HTMLElement;
  //props

  render() {
    return (
      <Host>
        <div class="pn-line-shape__container">
          <canvas class="pn-line-shape__line"></canvas>
          <canvas class="pn-line-shape__dot"></canvas>
        </div>
      </Host>
    );
  }
}
